export default [
 
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '/',
    redirect: '/' + process.env.VUE_APP_I18N_LOCALE ,
  },
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  {
    path: '/:local(ar|en)',
    name: 'default',
    meta: {
      middleware: ['localMiddleware'],
    },
    component: () => import('./views/form/artist.vue'),
  },
  {
    path: '/:local(ar|en)/qr-verify/:uuid([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})',
    name: 'qr_verify',
    meta: {
      middleware: ['localMiddleware'],
    },
    component: () => import('./views/form/qr_verify.vue'),
  },
  {
    path: '/:local(ar|en)/search',
    name: 'search',
    meta: {
      middleware: ['localMiddleware'],
    },
    component: () => import('./views/form/search.vue'),
  }
]
